import { render, staticRenderFns } from "./IconAlarm.vue?vue&type=template&id=f2fc65a4"
import script from "./IconAlarm.vue?vue&type=script&lang=js"
export * from "./IconAlarm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports